import "../common/Global.mixins.ts"
import "../common/Array.mixins.ts"
import "../common/Math.mixins.ts"
import "../common/String.mixins.ts"
import "../common/Number.mixins.ts"
import "@simonwep/pickr/dist/themes/nano.min.css"
import "whatwg-fetch"
import SkillBoardRenderer from "./skill-board/SkillBoardRenderer"
import SkillBoardSystem from "./skill-board/SkillBoardSystem"
import SkillBoardEditor from "./skill-board/SkillBoardEditor"
import SkillBoardAllocator from "./skill-board/SkillBoardAllocator"
import SkillBoardUserMixin from "./skill-board/SkillBoardUserMixin"
import axios from 'axios'

const EDITOR_MODE = false

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.timeout = 30000

class GameClient {
	isLoaded: boolean = false
	skillBoardRenderer: SkillBoardRenderer
	skillBoardSystem: SkillBoardSystem
	skillBoardEditor: SkillBoardEditor
	skillBoardAllocator: SkillBoardAllocator

	constructor() {}

	initialize() {
		this.skillBoardRenderer = new SkillBoardRenderer()
		this.skillBoardRenderer.initialize(<HTMLCanvasElement>document.getElementById("skill-render-canvas"))

		this.skillBoardSystem = new SkillBoardSystem({
			skillBoardRenderer: this.skillBoardRenderer,
		})
		const container = this.skillBoardSystem.init()

		if(EDITOR_MODE) {
			this.skillBoardEditor = new SkillBoardEditor({ 
				skillBoardRenderer: this.skillBoardRenderer,
				skillBoardSystem: this.skillBoardSystem,
			})
			this.skillBoardRenderer.foregroundLayer.addChild(container)
		} else {
			let params = new URLSearchParams(location.search)
			let charName = params.get('name')
			if (!charName) {
				alert('You must access this page via your Account/Character pages in order to modify a character\'s skill tree.')
				return
			}
			axios.get(`http://solus.kicks-ass.net/character/get_character_skill_tree.php?name=${charName}`)
				.then((response) => {
					const json = response.data
					console.log({
						json
					})
					const player = this.loadPlayerData(json)
					for (let i = 0; i < player.allocatedNodeIds.length; i++) {
						player.allocatedNodeIds[i] = Number.parseInt(player.allocatedNodeIds[i] as any)
					}
					this.loadAllocatorWithPlayer(player)
					this.skillBoardRenderer.foregroundLayer.addChild(container)
				})

		}
	}

	loadPlayerData(playerJson) {
		const player: SkillBoardUserMixin = {
			name: playerJson.name,
			isOwner: playerJson.isOwner,
			allocatedNodeIds: playerJson.allocatedNodeIds,
			visibleNodeIds: [],
			skillPoints: playerJson.skillPoints,
		}
		return player
	}

	loadAllocatorWithPlayer(player) {
		this.skillBoardAllocator = new SkillBoardAllocator({
			player: player,
			skillBoardRenderer: this.skillBoardRenderer,
			skillBoardSystem: this.skillBoardSystem,
		})

		this.skillBoardAllocator.reapplyAllNodesBasedOnUserAllocations(player)
		this.skillBoardAllocator.bindHandlers(player)
	}

	update(delta: number, now: any) {
		this.skillBoardRenderer.update(delta)
	}
}

export default GameClient
